<section>
  <img [ngClass]="{'in': in}" src="assets/if-logo.png" alt="">
  <div class="not-found">
    Pagina non trovata
  </div>
</section>
